const featuredBlog = new Swiper('.swiper.featured-blog', {
    spaceBetween: 13,
    slidesPerView: 1.2,
    breakpoints: {
      768: {
        touchRatio: 0,
        spaceBetween: 49,
        slidesPerView: 3,
      }
    }
  });